

import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  X,
  LayoutDashboard,
  Clock,
  DollarSign,
  User,
  HelpCircle,
  QrCode,
  FileText,
  ScrollText,
  LogOut,
} from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { toast } from "react-toastify";
import "./Sidebar.css";

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  

  // Safe profile image
  const getProfileImage = () => {
    if (!user) return "";

    if (typeof user.profileImage === "object" && user.profileImage?.url)
      return user.profileImage.url;

    if (typeof user.profileImage === "string") {
      if (user.profileImage.startsWith("http")) return user.profileImage;
      return `https://api.rismicmart.com${user.profileImage}`;
    }

    return `https://ui-avatars.com/api/?name=${encodeURIComponent(
      user?.fullName || "DP"
    )}&background=007b68&color=fff&size=200`;
  };

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose}></div>}

      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        {/* ---------- Profile Section Wrapper ---------- */}
        <div className="sidebar-profile-wrapper">
          {/* Close Button */}
          <button className="sidebar-close-btn" onClick={onClose}>
            <X size={20} />
          </button>

          {/* Avatar + Name */}
          <div
            className="sidebar-profile-section"
            onClick={() => {
              navigate("/profile");
              onClose();
            }}
            style={{ cursor: "pointer" }}
          >
            <img
              src={getProfileImage()}
              alt="Profile"
              className="sidebar-big-avatar"
              onError={(e) => {
                e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                  user?.fullName || "DP"
                )}&background=007b68&color=fff&size=200`;
              }}
            />

            {/* Dynamic Name Display */}
            <h3 className="sidebar-profile-title">
              {user?.fullName || "Delivery Partner"}
            </h3>
          </div>
        </div>

        {/* ---------- Menu ---------- */}
        <nav className="sidebar-menu">
          <Link
            to="/dashboard"
            className={location.pathname === "/dashboard" ? "active" : ""}
            onClick={onClose}
          >
            <LayoutDashboard size={18} /> Dashboard
          </Link>

          <Link
            to="/history"
            className={location.pathname === "/history" ? "active" : ""}
            onClick={onClose}
          >
            <Clock size={18} /> Pending Delivery
          </Link>

          <Link
            to="/earnings"
            className={location.pathname === "/earnings" ? "active" : ""}
            onClick={onClose}
          >
            <DollarSign size={18} /> My Earnings
          </Link>

          <Link
            to="/profile"
            className={location.pathname === "/profile" ? "active" : ""}
            onClick={onClose}
          >
            <User size={18} /> Profile
          </Link>

          <Link
            to="/support"
            className={location.pathname === "/support" ? "active" : ""}
            onClick={onClose}
          >
            <HelpCircle size={18} /> Support
          </Link>

          <Link
            to="/payment"
            className={location.pathname === "/payment" ? "active" : ""}
            onClick={onClose}
          >
            <QrCode size={18} /> Payment Scanner
          </Link>

          <Link
            to="/terms-and-conditions"
            className={
              location.pathname === "/terms-and-conditions" ? "active" : ""
            }
            onClick={onClose}
          >
            <FileText size={18} /> Terms & Conditions
          </Link>

          <Link
            to="/privacy-policy"
            className={location.pathname === "/privacy-policy" ? "active" : ""}
            onClick={onClose}
          >
            <ScrollText size={18} /> Privacy Policy
          </Link>

          
        </nav>
      </div>
    </>
  );
};

export default Sidebar;

